import { render, staticRenderFns } from "./Def.vue?vue&type=template&id=511c0744&"
import script from "./Def.vue?vue&type=script&lang=ts&"
export * from "./Def.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports